<template>
  <div class="configure-wrapper">
    <div class="title">配置</div>
    <product-configure></product-configure>
    <user-info></user-info>
  </div>
</template>

<script>
import ProductConfigure from './components/productConfigure.vue'
import UserInfo from './components/userInfo.vue'
import { karmaUrl } from '@/config'
export default {
  components: {
    ProductConfigure,
    UserInfo
  },
  methods: {
    goKarma () {
      window.open(karmaUrl + '/#/warning')
    }
  }
}
</script>

<style lang="scss" scoped>
.configure-wrapper {
  padding: 32px 40px;
  .title {
    font-size: 18px;
    font-weight: 500;
    color: rgba(29, 36, 60, 1);
    line-height: 28px;
    margin-bottom: 22px;
  }
  .warning-configure-box {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px 0px rgba(17, 39, 98, 0.04);
    border-radius: 4px;
    margin-bottom: 32px;
    .header {
      height: 62px;
      line-height: 62px;
      font-size: 18px;
      font-weight: 500;
      color: rgba(29, 36, 60, 1);
      padding-left: 27px;
      border-bottom: 1px solid #e6e7f0;
      box-sizing: border-box;
    }
    .info {
      height: 60px;
      padding-left: 27px;
      p {
        font-size: 14px;
        font-weight: 400;
        color: rgba(64, 73, 100, 1);
        line-height: 20px;
        line-height: 60px;
        span {
          color: rgba(19, 118, 255, 1);
          margin-left: 17px;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
